import { render, staticRenderFns } from "./EtapaDocumento.vue?vue&type=template&id=2a290ac0"
import script from "./EtapaDocumento.vue?vue&type=script&lang=js"
export * from "./EtapaDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports